













































































import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { AdminRoutes, ClientRoutes } from "@/data/enums/router";
import { Location as VueLocation } from "vue-router";
import { IClient } from "@/models/clients";
import { BrandConfigKeys } from "@/data/constants";
import Context from "@/mixins/context";

@Component({
  components: {
    "support-pin-reveal": () =>
      import("@/components/app/client/support/supportPinReveal.vue")
  },
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class ProfileDropdown extends Mixins(Context) {
  // Getters

  public user!: IClient;
  public clientDashboardRoute = ClientRoutes.DASHBOARD;

  public get accountRoute(): VueLocation {
    return {
      name: this.isAdmin ? `adminAccount` : ClientRoutes.ACCOUNT
    };
  }

  public get logoutRoute(): VueLocation {
    return {
      name: this.isAdmin ? AdminRoutes.LOGOUT : ClientRoutes.LOGOUT,
      params: {
        toast: this.$t("_.see_you_soon") as string
      }
    };
  }

  public get showSupportPin() {
    return this.$store.getters["brand/config"][
      BrandConfigKeys.SUPPORT_PIN_ENABLED
    ];
  }
}
